import React, { useState, useEffect } from 'react';
import img from '../../src/assets/usr_bg2.jpg';
import { Link } from 'react-router-dom';
import Apiconnect from "../services/Apiconnect.js";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Upgrade = () => {
  const [packageList, setPackageList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem('token');
      
      if (!token) {
        setError("Authentication token not found. Please login again.");
        toast.error("Authentication token not found. Please login again.");
        setIsLoading(false);
        return;
      }

      const response = await Apiconnect.getData("client_packages");
      
      if (response.data && response.data.status === 'success') {
        setPackageList(response.data.data || []);
      } else {
        const errorMessage = response.data?.message || 'Failed to fetch package list';
        setError(errorMessage);
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Error fetching packages:", error);
      setError('An error occurred while fetching packages');
      toast.error('An error occurred while fetching packages');
    } finally {
      setIsLoading(false);
    }
  };

  // Helper function to format package info into bullet points
  const formatPackageInfo = (info) => {
    if (!info) return [];
    return info.split('\r\n').filter(item => item.trim() !== '');
  };

  if (isLoading) {
    return <div className="text-center mt-5">Loading packages...</div>;
  }

  if (error) {
    return <div className="alert alert-danger mt-5">{error}</div>;
  }

  return (
    <>
      <div className="container-fluid">
        <div className="row mt-2 mb-4">
          {packageList.map((pack) => (
            <div className="col-md-4 mb-4" key={pack.id}>
              <div className="card text-center h-100">
                <div
                  className="card-header"
                  style={{
                    backgroundImage: `url(${img})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    color: "#fff",
                    fontWeight: "bold",
                    fontSize: "18px",
                  }}
                >
                  {pack.name}
                </div>
                <div className="card-body d-flex flex-column justify-content-center text-start">
                  <ul className="list-unstyled">
                    {formatPackageInfo(pack.info).map((item, index) => (
                      <li key={index}>
                        <span style={{ color: 'green', fontWeight: 'bold' }}>✓</span> {item}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="card-footer d-flex flex-column justify-content-center">
                  <p className="text-muted">Validity: <strong>{pack.pack_validity} Days</strong></p>
                  <Link to={`/customer/startpay/${pack.id}`}>
                    <button className="btn mb-4" style={{ backgroundColor: '#072848', color: 'white' }}>
                      Pay ₹{parseFloat(pack.price).toLocaleString('en-IN')} to Upgrade
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
        <ToastContainer/>
      </div>
    </>
  );
};

export default Upgrade;